import { servicebookPresentService } from '../../helpers/services/servicebookPresent.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const SERVICE_BOOK_PRESENT_MODULE = 'servicebookPresent'; 

// define action 
export const GET_ALL_SERVICE_BOOK_PRESENTS = 'getAllservicebookPresents';
export const GET_SERVICE_BOOK_PRESENT = 'getservicebookPresent';
export const UPDATE_SERVICE_BOOK_PRESENT = 'updateservicebookPresent';
export const CREATE_SERVICE_BOOK_PRESENT = 'createservicebookPresent';
export const UPDATE_SERVICE_BOOK_PRESENT_STATUS = 'updateservicebookPresentStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_SERVICE_BOOK_PRESENTS_REQUEST = "getAllservicebookPresents";
const GET_SERVICE_BOOK_PRESENT_REQUEST = "getservicebookPresent";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_SERVICE_BOOK_PRESENTS]({ commit }, { filter }) {
        servicebookPresentService
            .getAllservicebookPresents(filter)
            .then(
                (result) => {
                    commit(GET_ALL_SERVICE_BOOK_PRESENTS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_SERVICE_BOOK_PRESENT]({ commit }, { id }) {
        servicebookPresentService
            .getservicebookPresent(id)
            .then(
                (result) => {
                    commit(GET_SERVICE_BOOK_PRESENT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_SERVICE_BOOK_PRESENT]({ commit }, { data }) {
        commit(REQUEST)
        servicebookPresentService
            .updateservicebookPresent(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.servicebookPresent')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_SERVICE_BOOK_PRESENT]({ commit }, { data }) {
        commit(REQUEST)
        servicebookPresentService
            .createservicebookPresent(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess",[i18n.t('module.servicebookPresent')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_SERVICE_BOOK_PRESENT_STATUS]({ dispatch }, { filter, data }) {
        servicebookPresentService
            .updateservicebookPresentStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_SERVICE_BOOK_PRESENTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Service-book-present-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_SERVICE_BOOK_PRESENTS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
                updatedBy: o.updated_by,
                updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
            }
        })
    },
    [GET_SERVICE_BOOK_PRESENT_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            name: o.name,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdDateTime: filtersHelper.getDateFormat(o.created_date_time),
            updatedBy: o.updated_by,
            updatedDateTime: filtersHelper.getDateFormat(o.updated_date_time)
        }

    }
}


